import React from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';

function PuzzleTitle({ puzzleName, isDarkTheme, onThemeToggle, onTitleClick }) {
  return (
    <div className="puzzle-title">
      <div
        className="theme-toggle-button"
        onClick={onThemeToggle}
        title={isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'}
      >
        {isDarkTheme ? <FaSun /> : <FaMoon />}
      </div>
      <div
        className="puzzle-title-text"
        onClick={onTitleClick}
        style={{ cursor: 'pointer' }}
      >
        {puzzleName} ⚙️
      </div>
    </div>
  );
}

export default PuzzleTitle;